module.exports = __webpack_public_path__ + "static/media/kenneth_kwok.31cb002c.JPG";